import React from "react";
import FaqItem from "../UI/FaqItem";

const FAQ = ({ updateHeader, updateBreadcrumb }) => {
  updateHeader({
    title: "FAQ",
    description: "Frequently Asked Questions"
  });
  updateBreadcrumb([
    { label: "Home", link: "/" },
    { label: "FAQ", link: "/frequently-asked-questions" }
  ]);
  return (
    <div class="wrapper">
      <div class="row">
        <div class="col-md-12">
          <div class="faq">
            <h2>
              {/* <i class="fa fa-cubes" />  */}
              Coming Soon!
            </h2>

            {/* <FaqItem
              title=" How to aliquam at ipsum
                sapien?"
            >
              <h5>Aliquam at ipsum sapien</h5>
              <p>
                Class aptent taciti sociosqu ad litora torquent per conubia
                nostra, per inceptos himenaeos. Donec adipiscing vehicula tortor
                dapibus adipiscing.
              </p>
              <p>
                Nullam quis quam massa. Donec vitae metus tortor. Vestibulum vel
                diam orci. Etiam sollicitudin venenatis justo ut posuere. Etiam
                facilisis est ut ligula ornare accumsan. Class aptent taciti
                sociosqu ad litora torquent per conubia nostra, per inceptos
                himenaeos.
              </p>
            </FaqItem> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;



// WEBPACK FOOTER //
// ./src/_components/FAQ/index.js